import type { AchievementBackgroundProps } from '../Achievement';

export const NeutralPlaceholder = ({ size }: AchievementBackgroundProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.6748 6.09082C33.7091 3.38413 38.2909 3.38413 41.3252 6.09082L50.5303 14.3008C51.0285 14.7452 51.5699 15.1391 52.1465 15.4756L62.7998 21.6924C66.3117 23.7418 67.7283 28.1 66.0918 31.8223L61.127 43.1133C60.8583 43.7244 60.6516 44.3614 60.5098 45.0137L57.8887 57.0674C57.0248 61.0405 53.3181 63.7332 49.2725 63.3271L36.999 62.0957C36.3347 62.029 35.6653 62.029 35.001 62.0957L22.7275 63.3271C18.6819 63.7332 14.9752 61.0405 14.1113 57.0674L11.4902 45.0137C11.3484 44.3614 11.1417 43.7244 10.873 43.1133L5.9082 31.8223C4.27167 28.1 5.68833 23.7418 9.2002 21.6924L19.8535 15.4756C20.4301 15.1391 20.9715 14.7452 21.4697 14.3008L30.6748 6.09082Z"
      fill="#EAEAEC"
      stroke="#9FA3A7"
      strokeWidth="2"
    />
  </svg>
);
